import normalizeLocale from "@secureo/common/utils/normalizeLocale"

import { Locale } from "typings/i18n"
export interface GraphQLLocalizedString {
	locale: Locale
	value: string
}

const getValueFromLocalizedStringWithFallback = (
	localizedString: GraphQLLocalizedString[],
	locale: string,
) => {
	const { language } = normalizeLocale(locale)

	const localizedStringByLocale: { [locale: string]: string } = localizedString.reduce(
		(localizedStringByLocale, localizedString) => {
			const { locale, value } = localizedString

			return {
				...localizedStringByLocale,
				[locale.toLowerCase()]: value,
			}
		},
		{},
	)

	return (
		localizedStringByLocale?.[locale.toLowerCase()] ??
		localizedStringByLocale?.[language.toLowerCase()] ??
		localizedStringByLocale.de
	)
}

export default getValueFromLocalizedStringWithFallback
